import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { When } from 'react-if';

import * as ROUTES from '../../../constants/routes';
import { Categories, SidekickCategories } from '../../../static/categories';
import './FilterQuestionBar.css';
import Category from '../../elements/Category/Category';
import { IS_SIDEKICK_APP } from '../../../constants/projects';
import { ReactComponent as PostOpportunityIcon } from './post-oportunity-icon.svg';

const categoriesKey = IS_SIDEKICK_APP ? Object.keys(SidekickCategories) : Object.keys(Categories);

export const FilterQuestionBar = ({ isPreview, isDisabled, categoryToggle }) => {
    const navigate = useNavigate();

    const handleAddPostButtonClick = useCallback(() => {
        !isDisabled && navigate(ROUTES.CREATE_POST);
    }, [navigate, isDisabled]);

    const handleCategoryToggle = useCallback(
        category => {
            !isDisabled && categoryToggle(category);
        },
        [isDisabled, categoryToggle]
    );

    return (
        <div>
            <When condition={isPreview}>
                <div className="filter-question-bar__preview w-100" />
            </When>

            <div className="FilterQuestionBar-Wrapper row justify-content-center">
                <div className="d-flex align-items-center filter-bar w-100">
                    <div className="d-flex  justify-content-between w-100">
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-end align-items-center categories-wrap">
                                <When condition={!!categoriesKey}>
                                    <h2 className="categories-header">Categories:</h2>
                                    {categoriesKey.map(category => (
                                        <Category
                                            isDisabled={isDisabled}
                                            key={SidekickCategories[category].label}
                                            categoryToggle={handleCategoryToggle}
                                            category={
                                                IS_SIDEKICK_APP
                                                    ? SidekickCategories[category]
                                                    : Categories[category]
                                            }
                                        />
                                    ))}
                                </When>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <button
                                type="button"
                                className="filter-question-bar__add-button"
                                onClick={handleAddPostButtonClick}
                            >
                                <div className="post-opportunity-icon-wrap">
                                    <PostOpportunityIcon className="post-opportunity-icon" />
                                </div>
                                <span className="post-opportunity-button-text">
                                    Post an opportunity
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

FilterQuestionBar.propTypes = {
    isPreview: PropTypes.bool,
};

FilterQuestionBar.defaultProps = {
    isPreview: false,
};

export default React.memo(FilterQuestionBar);
